module.exports = __webpack_public_path__ + "static/media/download-icon.31a0b098.png";